import React from 'react'

const FuelInventory = () => {
  return (
    <div></div>
  )
}

export default FuelInventory